// src/app/modules/kumariRemitIpo/redux/service.ts
import axios from 'axios'
import moment from 'moment'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
const MODULE = 'capital-market-service'
const STEP = 'kumari-remit-ipo'

// ── CIF / account lookup ────────────────────────────────────────────────────────
// CBS is a separate core-banking system; swap this URL for the real CBS base URL
// when the sandbox is available. Keep as-is for development/staging.
const MOCK_CIF: any = {
  cif_number: 'CIF-123456-5678',
  account_name: 'Suresh Kumar Shrestha',
  gender: 'Male',
  date_of_birth: '1988-04-12',
  grandfather_name: 'Hari Bahadur Shrestha',
  father_name: 'Ram Bahadur Shrestha',
  mother_name: 'Sita Devi Shrestha',
  email: 'suresh.shrestha@example.com',
  mobile: '+971-50-1234567',
  citizenship_no: '12-01-78-09876',
  issue_district: 'Kathmandu',
  issued_date: '2065-03-14',
  permanent_address: 'Ward 5, Kathmandu Metropolitan City, Bagmati',
  source_of_income: 'Salary & Wages',
  occupation: 'Foreign Employment',
  company: 'Emirates Logistics LLC',
  annual_income: 4800000,
  existing_accounts: [
    {account_no: '1234567812345678', scheme: 'Normal Saving Account', status: 'ACTIVE', balance: 245000},
    {account_no: '1234567812340123', scheme: 'Call Deposit Account', status: 'ACTIVE', balance: 1120500},
  ],
  has_remit_ipo_account: false,
}

export const cifLookup = (account_number: string) => {
  // TODO: return axios.post(`${CBS_BASE_URL}/cif-lookup`, { account_number })
  const isDuplicate = account_number.endsWith('9999')
  return Promise.resolve({data: {...MOCK_CIF, has_remit_ipo_account: isDuplicate}})
}

// ── Application list — GET /case-reports ────────────────────────────────────────
export const fetchApplicationList = (params: any) => {
  const {fromDate, toDate, queue, ...rest} = params
  const queryParams = {
    ...rest,
    module: MODULE,
    queue,
    from_date: fromDate ? moment(fromDate).format('YYYY-MM-DD') : undefined,
    to_date: toDate ? moment(toDate).format('YYYY-MM-DD') : undefined,
  }
  return axios.get(`${API_URL}/case-reports`, {params: queryParams})
}

// ── Form submission — POST /submit/:module/:step ────────────────────────────────
export const submitApplication = (data: any) =>
  axios.post(`${API_URL}/submit/${MODULE}/${STEP}`, {form_data: data})

// ── Fetch single case — GET /case-reports/:case_id ─────────────────────────────
export const fetchCase = (case_id: string) =>
  axios.get(`${API_URL}/case-reports/${case_id}`, {params: {module: MODULE}})

// ── Checker action — POST /case-reports/:case_id/review ────────────────────────
export const checkerAction = (action: string, case_id: string, remarks: string) =>
  axios.post(`${API_URL}/case-reports/${case_id}/review`, {action, remarks, module: MODULE})
